function createArrayCache(options = {}) {
  const data = new Map();

  function gc() {
    const now = Date.now();
    for (const [key, [, expires]] of data) {
      if (expires <= now) {
        data.delete(key);
      }
    }
  }

  if (! options.disableGc) {
    setInterval(gc, 58000 + Math.floor(Math.random() * 4000)); // gc approx. every minute
  }

  return {
    gc,
    dump() {
      return Object.fromEntries(data);
    },
    set(key, value, ttl) {
      const expires = Date.now() + Math.floor(ttl * 1000);
      data.set(key, [value, expires]);
    },
    get(key) {
      const entry = data.get(key);
      if (!entry) {
        return undefined;
      }
      if (entry[1] <= Date.now()) {
        data.delete(key);
        return undefined;
      }
      return entry[0];
    },
    getRemainingTtlMs(key) {
      const entry = data.get(key);
      if (!entry) {
        return undefined;
      }
      const remaining = entry[1] - Date.now();
      if (remaining <= 0) {
        data.delete(key);
        return undefined;
      }

      return remaining;
    },
    delete(key) {
      data.delete(key);
    }
  };
}

module.exports = createArrayCache;